import { useDarkModeState } from '@hooks/common/use-dark-mode-state';
import React from 'react'
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';

interface DraftViewerProps {
  compareMethod: any;
  isSplitView: boolean;
  oldContent: string;
  newContent: string
}

function DraftViewer({
  isSplitView,
  compareMethod,
  oldContent,
  newContent,
}: DraftViewerProps) {
  const darkModeEnabled = useDarkModeState();

  return (
      <ReactDiffViewer
        leftTitle={
          isSplitView ? 'Current Article Content' : undefined
        }
        rightTitle={
          isSplitView ? 'Draft Article Content' : undefined
        }
        oldValue={oldContent || ''}
        newValue={newContent || ''}
        splitView={isSplitView}
        compareMethod={DiffMethod[compareMethod]}
        useDarkTheme={darkModeEnabled}
      />
  )
}

export default DraftViewer;
